import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin({
  parallel: true,
  setup () {
    // console.log('[NUXT] 99.branding.client.js')
    console.log('%c https://we-go.it/', 'padding:20px; background-color: rgb(227,70,71);')
  }
})
